import { Form, Input } from "decorator-form";

import { BlockStylesConfig, blockStylesInput } from "../common/BlockStylesConfig";
import { TypographyStylesConfig, typographyStylesInput } from "../common/TypographyStylesConfig";

@Form({title: "Dropdown Select View Config"})
export class DropdownSelectConfig {

	@Input({type: typographyStylesInput, title: "Text Style"})
	public typography?: TypographyStylesConfig;

	@Input({type: blockStylesInput, title: "Default State"})
	public defaultState?: BlockStylesConfig;

	@Input({type: blockStylesInput, title: "Hover"})
	public hoverState?: BlockStylesConfig;

	@Input({type: blockStylesInput, title: "Active/Open State"})
	public activeState?: BlockStylesConfig;

	@Input({type: blockStylesInput, title: "Disabled State"})
	public disabledState?: BlockStylesConfig;

}



// WEBPACK FOOTER //
// ./src/common/views/dropdownSelect/DropdownSelectConfig.ts